{
  "acceptedFileFormats": "Seuls les fichiers .docx, .pdf, .txt sont acceptés.",
  "actionCompetenceGroup": "Groupe de compétences pour action",
  "actionDeadline": "Date limite d'action",
  "actionDescription": "Description de l'action",
  "actionDuration": "Durée de l'action",
  "actionEarliestStart": "Début au plus tôt de l'action",
  "actionName": "Nom de l'action",
  "actions": "Actions",
  "actionsAndProjects": "Actions et projets",
  "actionsColon": "Actions : ",
  "actionsPerformerConstraints": "Contraintes des exécutants pour les actions",
  "add": "Ajouter",
  "addAdmin": "Ajouter un administrateur",
  "addAdminTitle": "Ajouter un administrateur",
  "addAnalyses": "Ajouter des analyses",
  "addAnalysis": "Ajouter une analyse",
  "addAnalysisGroup": "Ajouter un groupe d'analyses",
  "addChatbot": "Ajouter un chatbot",
  "addCompetenceGroup": "Ajouter un groupe de compétences",
  "addConstraint": "Ajouter une contrainte",
  "addGreyTask": "Ajouter une tâche grise",
  "addInstrument": "Ajouter un instrument",
  "addItemPlaceholder": "Ajouter {{item}}...",
  "addLocation": "Ajouter un lieu",
  "addMaintenance": "Ajouter une maintenance",
  "addMember": "Ajouter un membre",
  "addNewBundle": "Ajouter un nouveau lot",
  "addNewMaintenanceFor": "Ajouter une nouvelle maintenance pour {{assetName}}",
  "addNewTask": "Ajouter une nouvelle tâche",
  "addOffsite": "Ajouter OFFSITE",
  "addProjectGroup": "Ajouter un groupe de projets",
  "addProjectTemplate": "Ajouter un modèle de projet",
  "addRepository": "Ajouter au dépôt",
  "addRow": "Ajouter une ligne",
  "addSample": "Ajouter un échantillon",
  "addSamples": "Ajouter des échantillons",
  "addTeam": "Ajouter une équipe",
  "additionalInformation": "Informations supplémentaires",
  "administrators": "Administrateurs",
  "advanced": "Avancé",
  "allFilesProcessed": "Tous les fichiers téléchargés ont été traités",
  "allowMembersMoveOthersOperationalTasks": "Permettre aux membres de déplacer les tâches opérationnelles d'autrui",
  "allowedCompetenceGroups": "Groupes de compétences autorisés",
  "allowedInstruments": "Instruments autorisés",
  "amountOfSamples": "Nombre d'échantillons : {{count}}",
  "analyses": "Analyses",
  "analysesRelatedTo": "Analyses liées à {{product}}",
  "analysis": "Analyse",
  "analysisAndSampleDone": "L'analyse et l'échantillon sont terminés",
  "analysisDefinition": "définition d'analyse",
  "analysisDesignTool": "Outil de conception d'analyse",
  "analysisDone": "L'analyse est terminée",
  "analysisDraft": "Analyse BROUILLON",
  "analysisGroup": "Groupe d'analyses",
  "analysisGroupName": "Nom du groupe d'analyses",
  "analysisIsFlagged": "L'analyse est signalée",
  "analysisMustContainTaskDefinition": "L'analyse doit contenir une définition de tâche",
  "analysisName": "Nom de l'analyse",
  "analysisNameMustBeUnique": "Le nom de l'analyse doit être unique",
  "analysisNotPlanned": "Cette analyse n'est pas planifiée",
  "analysisPlanned": "L'analyse est planifiée",
  "analysisTaskBundle": "Lot d'analyses tâches {{index}}",
  "cdmoTargetedBundle": "Regrouper les tâches par nom d'analyse",
  "analysisTaskTimePerformerSamples": "Analyse Tâche – Durée, Exécutant, Nombre d'échantillons",
  "analysisTasks": "tâches d'analyse",
  "analysisTasksToBundle": "Tâches d'analyse à regrouper",
  "analysisTimePercentage": "Pourcentage du temps d'analyse par rapport au temps total (A2T)",
  "anywhere": "N'importe où",
  "apiToken": "Jeton API",
  "archiveMember": "Archiver le membre",
  "archived": "archivé",
  "areYouSureConnection": "Êtes-vous certain de vouloir cette connexion ?",
  "areYouSureConnectionMode": "Êtes-vous certain de vouloir passer en mode « avec connexion » ? Cela supprimera toutes les connexions actuelles",
  "areYouSureDeleteAdmin": "Êtes-vous certain de vouloir supprimer cet administrateur ?",
  "areYouSureDiscardSimulation": "Êtes-vous certain de vouloir abandonner les modifications effectuées en mode simulation ?",
  "areYouSurePublishSimulation": "Êtes-vous certain de vouloir publier les modifications effectuées en mode simulation ?",
  "areYouSureReset": "Êtes-vous certain de vouloir réinitialiser ? Cela supprimera tous les nœuds.",
  "areYouSureUnplanAllFutureActions": "Êtes-vous certain de vouloir déplanifier toutes les actions futures dans ce projet ?",
  "areYouSureWantToExit": "Êtes-vous certain de vouloir quitter ?",
  "arrival": "Arrivée",
  "assetAddedOrRemoved": "L'actif a été ajouté ou supprimé",
  "assetRequirementsForAsset": "Exigences d'actifs pour l'actif {{index}}",
  "assets": "Actifs",
  "atLeast1LowercaseLetter": "au moins 1 lettre minuscule",
  "atLeast1Number": "au moins 1 chiffre",
  "atLeast1UppercaseLetter": "au moins 1 lettre majuscule",
  "atLeast8Characters": "au moins 8 caractères",
  "automaticImportConversionSheet": "Feuille de conversion d'importation {{type}} automatique",
  "automaticSheetConfiguration": "Configuration automatique de feuille",
  "availability": "Disponibilité",
  "availableTimeOneWeek": "Temps disponible une semaine : ",
  "avgAnalysisDuration": "Durée moyenne d'analyse : ",
  "avgSampleBatchInterval": "Intervalle moyen des lots d'échantillons : ",
  "avgSamplesAllocated": "Nombre moyen d'échantillons alloués : ",
  "backlog": "Arrière-plan",
  "booked": "Réservé",
  "bookedBy": "Réservé par",
  "byCompetenceGroup": "Par groupe de compétences",
  "byDeadline": "Par date limite",
  "byGroup": "Par groupe",
  "byText": "Par texte",
  "canBePerformedAnywhere": "Peut être effectué n'importe où",
  "canOnlyBePerformedOnSite": "Ne peut être effectué que sur site",
  "cancel": "Annuler",
  "cancelChanges": "Annuler les modifications",
  "cannotUnlockStartedTasks": "Vous ne pouvez pas déverrouiller car une ou plusieurs tâches sont commencées/en pause/terminées",
  "changeLogs": "Journaux de modifications",
  "changesHaveBeenMade": "Des modifications ont été apportées, veuillez recharger pour les nouvelles données",
  "chatbotGreeting": "Bonjour, je suis votre CHATBOT IA, spécialisé dans la documentation d'aide de Plannertech et Librarian, ainsi que dans les dépôts de données que vous avez importés.\nVous pouvez également contacter notre support humain sur pt@arnvind.com de 9h à 16h CET.\nComment puis-je vous aider ? :-)",
  "chatbotName": "Nom du chatbot",
  "chatbotPlaceholder": "Écrivez une brève description du comportement du chatbot.",
  "chatbots": "Chatbots",
  "chattingWith": "Discussion avec {{name}}",
  "chooseAction": "Choisir une action",
  "chooseTask": "Choisir une tâche",
  "chooseWhatToAdd": "Choisir ce qu'il faut ajouter",
  "cleanUp": "Nettoyer",
  "clear": "Effacer",
  "clearConversation": "Effacer la conversation",
  "clearDates": "Effacer les dates",
  "clearTable": "Effacer le tableau",
  "clickToSelectOtherFiles": "Cliquez pour sélectionner d'autres fichiers",
  "close": "Fermer",
  "closeMessage": "fermer le message",
  "closePanel": "Fermer le panneau",
  "collaborator": "Collaborateur",
  "collaborators": "Collaborateurs",
  "domain": "Domaine",
  "color": "Couleur",
  "columnName": "Nom de la colonne",
  "companyWideChatbot": "Chatbot à l'échelle de l'entreprise",
  "competenceAndInstrumentConstraints": "Contraintes de compétence et d'instrument",
  "competenceGroup": "Groupe de compétences",
  "competenceGroupNameExists": "Un groupe de compétences portant ce nom existe déjà",
  "competenceGroups": "Groupes de compétences",
  "competenceGroupsColon": "Groupes de compétences : ",
  "configuration": "Configuration",
  "confirm": "Confirmer",
  "confirmArchivalOfMember": "Confirmer l'archivage du membre : {{initials}}",
  "confirmClearTable": "Êtes-vous certain de vouloir effacer le tableau ?",
  "confirmDeleteAllData": "Confirmer ceci supprimera toutes les données {{type}}. Il n'y a pas de retour en arrière, même en mode simulation.",
  "confirmDeleteAllUnplannedProjects": "Confirmer ceci supprimera tous les projets sans actions placées sur le plan",
  "confirmDeleteAllUnplannedSamples": "Confirmer ceci supprimera tous les échantillons sans actions placées sur le plan",
  "confirmDeleteCompetenceGroup": "Confirmer la suppression du groupe de compétences :",
  "confirmDeleteInstrument": "Êtes-vous certain de vouloir supprimer l'instrument : {{name}} ?",
  "confirmDeleteMaintenance": "Êtes-vous certain de vouloir supprimer cette maintenance ?",
  "confirmDeleteSample": "Êtes-vous certain de vouloir supprimer cet échantillon non planifié ?",
  "confirmDeleteSampleInfo": "Confirmer ceci supprimera définitivement l'échantillon sélectionné",
  "confirmDeletion": "Confirmer la suppression",
  "confirmFailSamples": "Êtes-vous certain de vouloir marquer les échantillons sélectionnés comme échoués ?",
  "confirmFailSamplesInfo": "Confirmer ceci marquera les échantillons sélectionnés comme échoués. Un doublon sera placé dans le menu d'analyse non planifiée",
  "confirmFailSamplesQuestion": "Êtes-vous certain de vouloir marquer les échantillons sélectionnés comme échoués ?",
  "confirmShowPlannedSamplesInfo": "Confirmer ceci affichera les échantillons planifiés",
  "confirmShowPlannedSamplesQuestion": "Êtes-vous certain de vouloir afficher les échantillons planifiés ?",
  "confirmSortByTime": "Êtes-vous certain de vouloir trier par heure ?",
  "confirmUnplanAllFutureActions": "Êtes-vous certain de vouloir déplanifier toutes les actions futures dans ce projet ?",
  "confirmUnplanAllQuestion": "Êtes-vous certain de vouloir déplanifier tous les {{itemType}} ?",
  "confirmUnplanSamplesInfo": "Confirmer ceci déplanifiera les échantillons sélectionnés. Ils seront placés dans le menu d'analyse non planifiée",
  "confirmUnplanSamplesQuestion": "Êtes-vous certain de vouloir déplanifier les échantillons sélectionnés ?",
  "connectionCalculatedInWorkdays": "Connexion calculée en jours de travail",
  "connectionCount": "Nombre de connexions",
  "connections": "Connexions",
  "connectionsAdvancedWarning": "(L'utilisation de connexions avec date limite ou début au plus tôt sur les actions est réservée aux utilisateurs avancés)",
  "connectionsPerformersOnly": "Les connexions ne concernent que les exécutants – n'affectent pas l'allocation d'actifs",
  "contactArnvindSupport": "Veuillez contacter le support Arnvind sur pt@arnvind.com",
  "conversionSheet": "Feuille de conversion",
  "copyToClipboard": "copier dans le presse-papiers",
  "country": "Pays",
  "create": "Créer",
  "createANewColumn": "Créer une nouvelle colonne",
  "createAction": "Créer une action",
  "createChatbot": "Créer un chatbot",
  "createEditChatbots": "Créer/modifier les chatbots",
  "createEditRepositories": "Créer/modifier les dépôts",
  "createNewColumn": "Créer une nouvelle colonne",
  "createNewProject": "Créer un nouveau projet",
  "createSingleAction": "Créer une action unique",
  "createStage": "Créer une étape",
  "createStandardAction": "Créer une action standard",
  "currentlyProcessingRepository": "Traitement de ce dépôt en cours",
  "daily": "Quotidien",
  "date": "Date",
  "dateUnavailable": "Date non disponible",
  "day": "jour",
  "dayS": "jour(s)",
  "days": "jour(s)",
  "daysBeforeExpirationWarning": "Jours avant expiration pour afficher l'avertissement",
  "daysBetweenRecurrences": "Jours entre les récurrences",
  "deadline": "Date limite",
  "deadlineColon": "Date limite : ",
  "deadlineDate": "Date limite",
  "deadlineMustBeLaterThanEarliestStart": "La date limite doit être ultérieure ou égale au début au plus tôt",
  "deadlineTime": "Heure limite",
  "defaultChatbot": "Chatbot par défaut",
  "delete": "Supprimer",
  "deleteAllTypeTestData": "Supprimer toutes les données de test {{type}}",
  "deleteAllUnplannedProjects": "Supprimer tous les projets non planifiés",
  "deleteAllUnplannedSamples": "Supprimer tous les échantillons non planifiés",
  "deleteColumn": "Supprimer la colonne",
  "deleteCompetenceGroup": "Supprimer le groupe de compétences",
  "deleteCompetenceGroupWarning": "La suppression laissera les tâches dans les analyses suivantes sans groupe de compétences. Assurez-vous un remplacement avant la suppression.",
  "deleteConstraint": "Supprimer la contrainte",
  "deleteData": "Supprimer les données",
  "deleteInstrument": "Supprimer l'instrument",
  "deleteInstrumentWarning": "Il sera également supprimé pour d'autres équipes à ce lieu.",
  "deleteProjects": "Supprimer les projets",
  "deleteSample": "Supprimer l'échantillon",
  "deleteSamples": "Supprimer les échantillons",
  "deleteThisRow": "Supprimer cette ligne",
  "description": "Description",
  "designTool": "Outil de conception",
  "done": "Fait",
  "draft": "brouillon",
  "dragAndDropFiles": "Déposez les fichiers ici ou cliquez pour sélectionner des fichiers",
  "dragAndDropFolders": "Déposez les dossiers ici ou cliquez pour sélectionner des fichiers spécifiques",
  "dropFilesHere": "Déposez les fichiers ici",
  "dropFoldersHere": "Déposez les dossiers ici...",
  "duplicate": "Dupliquer",
  "durationHHMM": "Durée (HH:MM)",
  "earliestStart": "Début au plus tôt",
  "edit": "Modifier",
  "editAction": "Modifier l'action",
  "editAdmin": "Modifier l'administrateur",
  "editAnalysisGroup": "Modifier le groupe d'analyses",
  "editAnalysisTask": "Modifier la tâche d'analyse",
  "editChatbot": "Modifier le chatbot",
  "editCompetenceGroup": "Modifier le groupe de compétences",
  "editConnectionFromTo": "Modifier la connexion de {{from}} à {{to}}",
  "editConversation": "Modifier la conversation",
  "editGroup": "Modifier le groupe",
  "editInstrument": "Modifier l'instrument",
  "editItem": "Modifier {{item}}",
  "editLocationName": "Modifier le nom du lieu",
  "editMaintenanceFor": "Modifier {{name}} pour {{assetName}}",
  "editMember": "Modifier le membre",
  "editOffsite": "Modifier OFFSITE",
  "editProject": "Modifier le projet",
  "editProjectGroup": "Modifier le groupe de projets",
  "editProjectTemplate": "Modifier le modèle de projet",
  "editProjectTemplateDraft": "Modifier le brouillon du modèle de projet",
  "editRepository": "Modifier le dépôt",
  "editSampleName": "Modifier l'échantillon : {{name}}",
  "editSheet": "Modifier la feuille {{name}}",
  "editStandardAction": "Modifier l'action standard",
  "editTask": "Modifier la tâche",
  "editTeam": "Modifier l'équipe",
  "edited": "Modifié",
  "email": "e-mail",
  "emailCannotContainDoubleDots": "L'e-mail ne peut pas contenir '..'",
  "emailLabel": "E-mail",
  "endDate": "Date de fin",
  "enterSimulationMode": "Entrer en mode simulation",
  "errors": "Erreurs",
  "errorsProcessingRepository": "Des erreurs se sont produites lors du traitement de ce dépôt",
  "estimatedWorkloadOneWeek": "Charge de travail estimée une semaine : ",
  "exclusive": "Exclusif",
  "exclusiveSampleIndicator": "* Indique un échantillon exclusif",
  "exitSimulation": "QUITTER SIMULATION",
  "exitSimulationMode": "Quitter le mode simulation",
  "expand": "Développer",
  "exportToExcel": "Exporter vers Excel",
  "fail": "Échouer",
  "failSample": "Échantillon échoui",
  "failSelected": "Échouer la sélection",
  "failedLoading": "Échec du chargement : {{members}}",
  "failedToCreateMaintenance": "Échec de la création de la maintenance « {{name}} »",
  "failedToDeleteMaintenance": "Échec de la suppression de la maintenance « {{name}} »",
  "failedToMarkMaintenanceAsCompleted": "Échec du marquage de la maintenance « {{name}} » comme complétée",
  "failedToUpdateMaintenance": "Échec de la mise à jour de la maintenance « {{name}} »",
  "failedUploads": "Téléchargements échoués",
  "fileUpload": "Téléchargement de fichier",
  "fileUploadError": "Une erreur s'est produite lors du téléchargement du fichier",
  "filenameLabel": "Nom de fichier : ",
  "filesUploadedSuccessfully": "Fichiers téléchargés avec succès",
  "fillIn": "Remplir",
  "fillInIgnoreOverbooking": "Remplir en ignorant la surréservation",
  "filter": "Filtre",
  "filterByName": "Filtrer par nom",
  "filterBySampleName": "Filtrer par nom d'échantillon",
  "filterBySampleProductName": "Filtrer par nom d'échantillon/de produit",
  "filterByText": "Filtrer par texte",
  "finished": "Terminé",
  "flag": "Signaler",
  "flagSample": "Signaler l'échantillon",
  "followingErrorsWhileImporting": "Erreurs suivantes lors de l'importation :",
  "free": "Libre",
  "from": "De",
  "fromDate": "À partir de la date",
  "fromTime": "À partir de l'heure (HH:MM)",
  "fromTimeHH": "À partir de l'heure (HH)",
  "fromTimeHHMM": "À partir de l'heure (HH:MM)",
  "futureAnalysisTaskCantBe": "Une tâche d'analyse future ne peut pas être {{state}}",
  "generate": "Générer",
  "globalChatbot": "Chatbot global",
  "goBack": "Retour",
  "goBackToChat": "Retour au chat",
  "greyTaskTimePercentage": "Pourcentage du temps de tâche grise par rapport au temps total (G2T)",
  "groupMembers": "Membres du groupe",
  "groupName": "Nom du groupe",
  "help": "Aide",
  "helpBackToApp": "Retour à l'application",
  "helpHome": "Accueil de l'aide",
  "helpPageNotFound": "Page d'aide introuvable",
  "helpSearch": "Rechercher dans l'aide",
  "helpAppTitle": "Aide Plannertech",
  "hidden": "Masqué",
  "hideMore": "Masquer plus",
  "highestPriority": "1 est la priorité la plus élevée",
  "history": "Historique",
  "home": "Accueil",
  "hour": "heure",
  "iCalendarOutlookIntegration": "Intégration iCalendar / Outlook",
  "iap": "IAP",
  "ignoreAllGreytasks": "Ignorer toutes les tâches grises",
  "ignoredByIap": "Ignoré par IAP",
  "includingToday": "Y compris aujourd'hui",
  "importedTask": "Tâche importée",
  "busyOnAnotherTeam": "Occupé dans une autre équipe",
  "includeDoneSamples": "Inclure les échantillons terminés",
  "includeOverdue": "Inclure les retards",
  "includeToday": "Inclure aujourd'hui",
  "iapIncludeTodayWarningIAP": "Avertissement IAP et Inclure aujourd'hui – les tâches planifiées plus tôt aujourd'hui peuvent également être déplacées à moins qu'elles ne soient verrouillées !",
  "iapIncludeTodayWarningFillIn": "Avertissement Remplir et Inclure aujourd'hui – les tâches planifiées plus tôt aujourd'hui peuvent également recevoir de nouveaux échantillons alloués !",
  "initials": "Initiales",
  "inputLastMonth": "Entrée mois dernier",
  "inputThisMonth": "Entrée ce mois-ci",
  "instrument": "Instrument",
  "instrumentConstraints": "Contraintes d'instrument",
  "instrumentLog": "Journal d'instrument",
  "instrumentName": "Nom de l'instrument",
  "instrumentOffset": "Décalage d'instrument (HH:MM)",
  "instrumentOverbooking": "Surréservation d'instrument",
  "instrumentPerSampleDuration": "Durée d'instrument par échantillon (HH:MM:SS)",
  "instrumentSetup": "Configuration d'instrument {{name}}",
  "instrumentSetuptime": "Temps de configuration d'instrument (HH:MM)",
  "instrumentTime": "Temps d'instrument",
  "instrumentView": "Vue de l'instrument",
  "instruments": "Instruments",
  "instrumentsWithExpiredMaintenance": "Il y a des instruments avec maintenance expirée",
  "instrumentsWithMaintenanceReminders": "Il y a des instruments avec rappels de maintenance",
  "integration": "Intégration",
  "invalidDate": "Date invalide",
  "invalidOutlookLink": "Lien iCalendar / Outlook invalide",
  "isInSimulationMode": "{{initials}} est en mode simulation",
  "isSimulating": "{{initials}} simule...",
  "keepExistingConnections": "Conserver les connexions existantes",
  "labelAlreadyLoaded": "Déjà chargé : {{count}}",
  "labelCreated": "Créé : {{count}}",
  "labelDeleted": "Supprimé : {{count}}",
  "labelDeletedOrFinished": "Supprimé ou marqué comme terminé : {{count}}",
  "labelDoneDeleted": "Fait/Supprimé : {{count}}",
  "labelUpdatedInformation": "Informations mises à jour : {{count}}",
  "lastErrorLog": "Dernier journal d'erreur",
  "lastWeek": "Semaine dernière",
  "latestArrival": "Arrivée la plus tardive",
  "leadTimesInWorkDays": "Délais en jours de travail",
  "leaveEmptyIfNotUsed": "(laisser vide s'il n'est pas utilisé)",
  "leaveEmptyIfNotUsedDefault": "(laisser vide s'il n'est pas utilisé, par défaut={{defaultValue}})",
  "loadFromTemplate": "Charger à partir du modèle",
  "loading": "CHARGEMENT",
  "loadingEllipsis": "Chargement...",
  "loadingSamples": "Chargement des échantillons",
  "loadingSheet": "Chargement de la feuille",
  "loadingSheets": "Chargement des feuilles",
  "location": "Lieu",
  "locationColon": "Lieu : {{name}}",
  "locationName": "Nom du lieu",
  "lockItemType": "Verrouiller {{itemType}}",
  "lockSamples": "Verrouiller les échantillons",
  "lockUnlockSamplesLabel": "Verrouiller/Déverrouiller les échantillons :",
  "locks": "Verrous",
  "locksAllFutureAnalysisTasks": "Verrouille toutes les tâches d'analyse futures planifiées",
  "locksAllFutureProjectActions": "Verrouille toutes les actions de projet futures planifiées",
  "login": "Connexion",
  "logout": "Déconnexion",
  "maintenanceCreatedSuccessfully": "Maintenance « {{name}} » créée avec succès",
  "maintenanceDeletedSuccessfully": "Maintenance « {{name}} » supprimée avec succès",
  "maintenanceExpired": "Maintenance expirée",
  "maintenanceExpiresInDays": "La maintenance expire dans moins de {{days}} jours",
  "maintenanceMarkedAsCompleted": "Maintenance « {{name}} » marquée comme complétée",
  "maintenanceName": "Nom de la maintenance",
  "maintenanceUpdatedSuccessfully": "Maintenance « {{name}} » mise à jour avec succès",
  "mandatoryIfRecurrenceUsed": "(obligatoire si la récurrence est utilisée)",
  "manualSample": "Échantillon manuel",
  "manualSheetConfiguration": "Configuration de feuille manuelle",
  "markAsDone": "Marquer comme fait",
  "maxSampleCount": "Nombre d'échantillons maximum",
  "maxSampleCountLabel": "Nombre max. d'échantillons : ",
  "maxTimeBetweenActions": "Temps maximum entre les actions (DD:HH:MM)",
  "maxTimeBetweenTasks": "Temps maximum entre les tâches (DD:HH:MM)",
  "member": "Membre",
  "memberHasEnabledICalendarOutlookIntegration": "Le membre a activé l'intégration iCalendar / Outlook",
  "memberHasEnabledOutlook": "Le membre a activé l'intégration iCalendar / Outlook",
  "memberPermissions": "Permissions des membres",
  "memberPlan": "Plan des membres",
  "memberTime": "Temps des membres",
  "membersGoDirectlyToMemberPlan": "Les membres vont directement au plan des membres",
  "message": "Message",
  "metric": "Métrique",
  "minSampleCount": "Nombre d'échantillons minimum",
  "minSampleMustBeLowerThanMax": "Le nombre minimum d'échantillons doit être inférieur au nombre maximum",
  "minTimeBetweenActions": "Temps minimum entre les actions (DD:HH:MM)",
  "minTimeBetweenTasks": "Temps minimum entre les tâches (DD:HH:MM)",
  "minTimeMustBeSmallerThanMax": "Le temps minimum entre doit être inférieur au temps maximum entre",
  "minimumDuration": "Durée minimale : {{time}}",
  "minute": "minute",
  "missingPasswordRequirements": "Exigences de mot de passe manquantes : {{requirements}}",
  "months": "Mois",
  "movedBy": "Déplacé par",
  "movedFrom": "Déplacé de",
  "movedTo": "Déplacé vers",
  "mustBeIcsLink": "Doit être un lien .ics",
  "name": "Nom",
  "namePerformer": "exécutant {{name}}",
  "nameTooLongTitle": "Nom trop long (max 100 caractères)",
  "newAnalysisTaskBundle": "Nouveau lot de tâches d'analyse",
  "newChat": "Nouveau chat",
  "newInstrument": "Nouvel instrument",
  "newProject": "Nouveau projet",
  "newProjectTemplateDraft": "Nouveau brouillon de modèle de projet",
  "newStart": "Nouveau début",
  "nextDay": "Jour suivant",
  "nextWeek": "Semaine prochaine",
  "no": "Non",
  "noAnalysesForProduct": "Aucune analyse trouvée pour ce produit.",
  "noAssetsFound": "Aucun actif trouvé",
  "noChanges": "Aucune modification",
  "noChatbotSelected": "Aucun chatbot sélectionné",
  "noDataFound": "Aucune donnée trouvée",
  "noErrorsToDisplay": "Aucune erreur à afficher.",
  "noGroup": "Aucun groupe",
  "noMembersLoaded": "Aucun membre chargé.",
  "noOfRecurrences": "Nombre de récurrences",
  "noReferencesAvailable": "Aucune référence disponible.",
  "noSamples": "Aucun échantillon",
  "noSamplesAvailable": "Aucun échantillon disponible",
  "noSearchResults": "Aucun résultat de recherche",
  "noTimeLimitUnlessSpecified": "Aucune limite de temps sauf indication contraire",
  "none": "Aucun",
  "default": "Défaut",
  "notAvailable": "N/A",
  "notEnoughRoomForDuration": "Pas assez de place pour la durée",
  "notStarted": "Non commencé",
  "numberOfObservations": "Nombre d'observations",
  "numberOfRecurrences": "Nombre de récurrences",
  "numericInputBetweenTimeRange": "Veuillez donner une entrée numérique entre 00:00 et 23:59",
  "offsiteCalendar": "Calendrier OFFSITE",
  "ok": "OK",
  "oldInstrument": "Ancien instrument",
  "oldStart": "Ancien début",
  "onlyAdvancedUsersInfo": "Seuls les utilisateurs avancés utilisent à la fois le début au plus tôt et les connexions",
  "onsite": "Sur site",
  "openReferences": "Ouvrir les références",
  "operationalGreyTaskTimePercentage": "Pourcentage du temps de tâche grise opérationnelle par rapport au temps total (OG2T)",
  "operationalTask": "Tâche opérationnelle",
  "otherPlannerSimulating": "{{initials}} est en mode simulation",
  "outlookLinkLabel": "Lien iCalendar / Outlook",
  "outputLastMonth": "Sortie mois dernier",
  "outputThisMonth": "Sortie ce mois-ci",
  "parentColumn": "Colonne parent",
  "password": "Mot de passe",
  "paused": "En pause",
  "peopleSetup": "Configuration du personnel",
  "perSampleDuration": "Durée par échantillon (HH:MM:SS)",
  "perSampleDurationForPeopleSetup": "Durée par échantillon pour la configuration du personnel",
  "performerConstraintsCount": "Nombre de contraintes d'exécutants",
  "performerConstraintsLabel": "Contraintes d'exécutants",
  "permanentApiToken": "Jeton API permanent",
  "permanentApiTokenDescription": "Ceci est un jeton API permanent qui vous permet d'accéder à votre équipe via notre API. Copiez-le et stockez-le dans un endroit sûr.",
  "pinConversation": "Épingler la conversation",
  "planned": "Planifié",
  "planner": "Planificateur",
  "plannertechLanguage": "Langue Plannertech",
  "plannertechVariable": "Variable Plannertech",
  "pleaseChooseColor": "Veuillez choisir une couleur pour l'analyse",
  "pleaseFillOutAnalysisName": "Veuillez remplir le nom de l'analyse",
  "pleaseFillOutRequiredTaskParams": "Veuillez remplir les paramètres de tâche requis",
  "pleaseGiveEmptyOrFullInput": "Veuillez donner une entrée vide ou complète",
  "pleaseGiveNumericInput": "Veuillez donner une entrée numérique",
  "pleaseInputValidDate": "Veuillez entrer une date valide",
  "pleaseSelectAtLeastOneItem": "Veuillez sélectionner au moins un élément",
  "pleaseSelectColor": "Veuillez sélectionner une couleur",
  "pleaseSelectFirstDay": "Veuillez sélectionner le premier jour.",
  "pleaseSelectLastDay": "Veuillez sélectionner le dernier jour.",
  "pleaseSelectTimezone": "Veuillez sélectionner un fuseau horaire",
  "previousDay": "Jour précédent",
  "primary": "Principal",
  "primaryInstrument": "Instrument principal",
  "prioritizeByDeadline": "Prioriser IAP par date limite",
  "prioritizeByPriority": "Prioriser IAP par numéro de priorité",
  "priority": "Priorité",
  "priorityHigh": "(Élevée)",
  "priorityLow": "(Basse)",
  "priorityMedium": "(Moyenne)",
  "process": "Processus",
  "processed": "Traité",
  "processing": "Traitement...",
  "processingInProgress": "Traitement",
  "productName": "Nom du produit",
  "project": "Projet",
  "projectActions": "actions de projet",
  "projectBatchNumber": "Numéro de lot du projet",
  "projectDeadline": "Date limite du projet",
  "projectDescription": "Description du projet",
  "projectEarliestStart": "Début au plus tôt du projet",
  "projectGroup": "Groupe de projets",
  "projectGroupName": "Nom du groupe de projets",
  "projectImport": "Importation de projet",
  "projectImportVariable": "Variable d'importation de projet",
  "projectMaterialDescription": "Description du matériau de projet",
  "projectMaterialNumber": "Numéro de matériau de projet",
  "projectName": "Nom du projet",
  "projectPriority": "Priorité du projet",
  "projectReleaseDate": "Date de sortie du projet",
  "projectSupplierName": "Nom du fournisseur du projet",
  "projectSupplierNumber": "Numéro du fournisseur du projet",
  "projectTemplate": "modèle de projet",
  "projectTemplates": "Modèles de projet",
  "projectTimePercentage": "Pourcentage du temps de projet par rapport au temps total (P2T)",
  "projectView": "Vue du projet",
  "projects": "Projets",
  "projectsAndActions": "Projets et actions",
  "promptPrefix": "Préfixe de requête",
  "promptTooLongTitle": "Requête trop longue (max 1200 caractères)",
  "publish": "PUBLIER",
  "publishSimulationChanges": "Publier les modifications du mode simulation",
  "qcLibrarian": "QC Librarian",
  "qcLibrarianTitle": "Librarian QC 3.8",
  "recur": "Récurrence",
  "recurEvery": "Récurrence tous les",
  "recurrence": "Récurrence",
  "reduce": "Réduire",
  "references": "Références",
  "rejectedFileTypes": "Types de fichiers rejetés",
  "rejectedFilesIncompatible": "Les fichiers suivants ont été rejetés en raison de formats incompatibles",
  "reminderDaysBeforeEndDate": "Rappel (jours avant la date de fin)",
  "remove": "Supprimer",
  "removeAnalysisFromProduct": "Supprimer {{name}} de ce produit",
  "removeAsset": "Supprimer l'actif",
  "removeEverything": "Tout supprimer",
  "removeInstrument": "Supprimer l'instrument",
  "reportGenerator": "Générateur de rapports",
  "reports": "Rapports",
  "repositories": "Dépôts",
  "repositoryCurrentlyProcessing": "Le dépôt traite actuellement les fichiers. Veuillez actualiser la page pour voir la progression",
  "repositoryHasUnprocessedFiles": "Ce dépôt contient des fichiers non traités",
  "repositoryIsProcessed": "Ce dépôt est traité",
  "repositoryName": "Nom du dépôt",
  "reset": "Réinitialiser",
  "role": "Rôle",
  "row": "Ligne",
  "rowNumber": " ligne {{row}}",
  "runIAP": "Exécuter IAP",
  "runningIAP": "Exécution d'IAP",
  "sampleAnalysisName": "Nom de l'analyse d'échantillon",
  "sampleBatchNumber": "Numéro de lot d'échantillon",
  "sampleHighestPriority": "L'échantillon a la plus haute priorité",
  "sampleId": "ID d'échantillon",
  "sampleIdWithValue": "ID d'échantillon : {{id}}",
  "sampleImport": "Importation d'échantillon",
  "sampleImportVariable": "Variable d'importation d'échantillon",
  "sampleInProgressOnDoneAnalysis": "Échantillon en cours d'analyse terminée",
  "sampleIsDone": "L'échantillon est fait",
  "sampleLog": "Journal d'échantillon",
  "sampleLowestPriority": "L'échantillon a la plus basse priorité",
  "sampleMaterialNumber": "Numéro de matériau d'échantillon",
  "sampleName": "Nom de l'échantillon",
  "sampleObservation": "Observation d'échantillon",
  "sampleObservations": "Observations d'échantillon",
  "samplePercentage": "Pourcentage d'échantillon",
  "sampleProductDescription": "Description du produit d'échantillon",
  "sampleReceivedDate": "Date de réception de l'échantillon",
  "sampleStatus": "Statut de l'échantillon",
  "sampleView": "Vue d'échantillon",
  "samples": "Échantillons",
  "samplesWithName": "Échantillons portant le nom {{name}}",
  "samplesWithoutProduct": "Échantillons sans produit",
  "save": "Enregistrer",
  "saveAs": "Enregistrer sous",
  "saveAsDraft": "Enregistrer comme brouillon {{type}}",
  "saveAsNew": "Enregistrer comme nouveau",
  "saveAsNewAnalysis": "Enregistrer comme nouvelle analyse",
  "saveAsNewTemplate": "Enregistrer comme nouveau modèle",
  "saveAsType": "Enregistrer comme {{type}}",
  "scrollToTop": "Faire défiler vers le haut",
  "scrumView": "Vue Scrum",
  "scrumViewOrdering": "Ordre de la vue Scrum",
  "searchBySampleName": "Rechercher par nom d'échantillon...",
  "searchCountry": "Rechercher un pays",
  "seats": "Sièges",
  "second": "seconde",
  "secondaryInstrumentMustHaveAllowedInstrument": "L'instrument secondaire doit avoir au moins un instrument autorisé",
  "selectAll": "Sélectionner tout",
  "selectChatbot": "Sélectionner un chatbot",
  "selectDefaultChatbot": "Sélectionner le chatbot par défaut",
  "selectEntireDay": "Sélectionner la journée entière",
  "selectEntireWorkday": "Sélectionner la journée de travail entière",
  "selectLocation": "Sélectionner un lieu...",
  "selectSamples": "Sélectionner les échantillons",
  "selectState": "Sélectionner l'état...",
  "selectTimezone": "Sélectionner un fuseau horaire...",
  "selectType": "Sélectionner le type",
  "selectedFilesReadyForSubmit": "Fichiers/dossiers sélectionnés prêts pour la soumission :",
  "selectedProduct": "Produit sélectionné",
  "setPlannedValues": "Définir les valeurs planifiées",
  "settings": "Paramètres",
  "settingsForQcLibrarian": "Paramètres pour le Librarian QC",
  "setupTimeForPeopleSetup": "Temps de configuration pour la configuration du personnel",
  "setuptime": "Temps de configuration (HH:MM)",
  "sheetName": "Nom de la feuille",
  "sheetNameLabel": "Nom de la feuille",
  "sheetType": "Type de feuille",
  "shouldBeEqualTo": "doit être égal à",
  "shouldNotBeEqualTo": "ne doit pas être égal à",
  "showAnalyses": "Afficher les analyses",
  "showErrors": "Afficher les erreurs",
  "showLastErrorLog": "Afficher le dernier journal d'erreur",
  "showLibrarian": "Afficher le Librarian",
  "showLog": "Afficher le journal",
  "showMore": "Afficher plus",
  "showOnPlan": "Afficher sur le plan",
  "showProjects": "Afficher les projets",
  "shown": "Visible",
  "simulationMode": "Mode simulation",
  "simulationModeLogoutWarning": "Vous êtes actuellement en mode simulation. La déconnexion abandonnera les modifications !",
  "simulationModeOccupied": "MODE SIMULATION OCCUPÉ",
  "simulationModeUpper": "MODE SIMULATION",
  "somethingWentWrong": "Une erreur s'est produite",
  "sortByProduct": "Trier par produit",
  "sortByTime": "Trier par heure",
  "sortByTimeDescription": "Ordonne les actions d'arriéré et À faire selon leurs dates limites, et Planifié et Terminé selon leur heure de début",
  "speechToTextLanguage": "Langue pour la conversion parole-texte",
  "spreadsheetColumnName": "Nom de la colonne de feuille de calcul",
  "stage": "Étape",
  "standardActions": "Actions standard",
  "start": "Début",
  "startDate": "Date de début",
  "startDateCheckboxInfo": "Quand vous cochez, la date limite du projet, la date limite d'action et le début de l'action se déplaceront par rapport au début du projet",
  "startEndDate": "Date de début/fin",
  "startProcessingInfo": "Cela démarrera le traitement du dépôt. Cela peut prendre du temps selon la taille du dépôt",
  "startRecurrence": "Récurrence de début",
  "startTime": "Heure de début",
  "started": "Commencé",
  "state": "État",
  "status": "Statut",
  "submit": "Soumettre",
  "successfullyLoaded": "Chargé avec succès : {{members}}",
  "successfullyUploadedFiles": "Fichiers téléchargés avec succès",
  "systemPrompt": "Requête système",
  "taskBelongsToTeam": "La tâche appartient à l'équipe : {{team}}",
  "taskCount": "Nombre de tâches",
  "taskDesignTool": "Outil de conception de tâche",
  "taskLog": "Journal des tâches",
  "taskName": "Nom de la tâche",
  "taskPerformerConstraints": "Contraintes d'exécutants de tâche",
  "tasks": "Tâches",
  "team": "Équipe",
  "teamChatbot": "Chatbot d'équipe",
  "teamLabel": "Équipe : {{name}}",
  "teamMember": "Membre de l'équipe",
  "teamName": "Nom de l'équipe",
  "teamPlan": "Plan de l'équipe",
  "teamUsageTitle": "Utilisation de {{name}}",
  "teams": "Équipes",
  "templateIsDraft": "Ce modèle de projet est un brouillon",
  "templateName": "Nom du modèle",
  "theProjectIsDone": "Le projet est terminé",
  "timeConstraints": "Contraintes de temps",
  "timeHHMM": "Heure (HH:MM)",
  "timePeriod": "Période",
  "timestamp": "Horodatage",
  "timezone": "Fuseau horaire",
  "to": "À",
  "toConfirmDeletionType": "Pour confirmer la suppression, tapez {{keyword}}",
  "toConfirmDeletionTypeDeleteData": "Pour confirmer la suppression, tapez {{keyword}} et appuyez sur confirmer. Cela supprimera définitivement les données de test, même en mode simulation. Il n'y a pas de retour en arrière.",
  "toConfirmDeletionTypeKeyword": "Pour confirmer la suppression, tapez {{keyword}} et appuyez sur confirmer",
  "toDate": "À la date",
  "toDo": "À faire",
  "toTime": "Jusqu'à l'heure (HH:MM)",
  "toTimeHH": "Jusqu'à l'heure (HH)",
  "toTimeHHMM": "Jusqu'à l'heure (HH:MM)",
  "today": "Aujourd'hui",
  "tokens": "Jetons",
  "total": "Total",
  "normalSeats": "Normal",
  "tryReloadingOrContactSupport": "Essayez de recharger ou contactez le support si le problème persiste !",
  "type": "Type",
  "typeBeforeConfirming": "tapez {{keyword}} avant de confirmer",
  "typeOrSelect": "Tapez ou sélectionnez...",
  "typeYourMessage": "Tapez votre message...",
  "unassignedSamples": "Échantillons non assignés",
  "unassignedSamplesFor": "Échantillons non assignés pour « {{name}} »",
  "unflag": "Dissignaler",
  "unflagSample": "Dissignaler l'échantillon",
  "unlockItemType": "Déverrouiller {{itemType}}",
  "unlockSamples": "Déverrouiller les échantillons",
  "unlocks": "Déverrouillages",
  "unlocksAllFutureAnalysisTasks": "Déverrouille toutes les tâches d'analyse futures planifiées",
  "unlocksAllFutureProjectActions": "Déverrouille toutes les actions de projet futures planifiées",
  "unnamed": "sans nom",
  "unpinConversation": "Dépingler la conversation",
  "unplan": "Déplanifier",
  "unplanAnalysis": "Déplanifier l'analyse",
  "unplanItemType": "Déplanifier {{itemType}}",
  "unplanSample": "Déplanifier l'échantillon",
  "unplanSelected": "Déplanifier la sélection",
  "unplanned": "Non planifié",
  "unplannedProjects": "Projets non planifiés",
  "unsavedChangesIn": "Il y a des modifications non enregistrées dans :",
  "updateIntegration": "Mettre à jour l'intégration",
  "updatedIcalOutlook": "iCalendar / Outlook mis à jour !",
  "uploadAborted": "Téléchargement annulé !",
  "uploadComplete": "Téléchargement terminé !",
  "uploadFailedForFile": "Le téléchargement a échoué pour le fichier : {{path}}",
  "uploadFinished": "Téléchargement terminé !",
  "uploadTo": "Télécharger vers {{name}}",
  "usage": "Utilisation",
  "used": "Utilisé",
  "usedAssets": "Actifs utilisés",
  "usedInstrument": "Instrument utilisé",
  "usedInstruments": "Instruments utilisés",
  "username": "Nom d'utilisateur",
  "value": "Valeur",
  "view": "Affichage",
  "viewAllAnalysesForProduct": "Afficher toutes les analyses pour ce produit",
  "viewAnalysisSamples": "Afficher les échantillons d'analyse",
  "viewCompact": "Vue compacte",
  "viewNormal": "Vue normale",
  "weekNumber": "Semaine {{week}}",
  "weekView": "Vue de la semaine",
  "dayView": "Vue du jour",
  "weekendView": "Vue du week-end",
  "screen": "Écran",
  "clickToSortBy": "Cliquez pour trier par {{column}}",
  "fileChangedPleaseReselect": "{{file}} a changé. Veuillez sélectionner à nouveau le fichier",
  "contentTooWideZoomOut": "Le contenu est trop large pour l'écran. Pour une meilleure expérience visuelle, dézoomez ({{key}} +/-)",
  "week": "Semaine",
  "weekly": "Hebdomadaire",
  "weeks": "semaine(s)",
  "withConnections": "avec connexions",
  "workHours": "Heures de travail",
  "workWeek": "Semaine de travail",
  "years": "Années",
  "yes": "Oui",
  "youAreInSimulationMode": "Vous êtes en mode simulation",
  "zeroHours": "0 heure",
  "addCustomer": "Ajouter un client",
  "addGlobalChatbot": "Ajouter un chatbot global",
  "addGlobalRepository": "Ajouter un dépôt global",
  "apiKey": "Clé API",
  "authenticationCode": "Code d'authentification",
  "authenticationCodeSentInfo": "Nous avons envoyé un code d'authentification à votre e-mail. Veuillez l'entrer ci-dessus avant la connexion",
  "chatbotPrefix": "Préfixe du chatbot",
  "chatbotSystemPrompt": "Requête système du chatbot",
  "chatbotSystemPrompts": "Requêtes système du chatbot",
  "citationGuidelines": "Directives de citation",
  "configureMember": "Configurer le membre",
  "createApiKey": "Créer une clé API",
  "creatingProject": "Création du projet",
  "currentQuestion": "Question actuelle",
  "customerAdminApiKeyForGlobalRepositories": "Clé API administrateur client pour dépôts globaux",
  "dateFormatYyyyMmDd": "YYYY-MM-DD",
  "deleteApiKey": "Supprimer la clé API",
  "descriptionPrompt": "Requête de description",
  "editGlobalMessage": "Modifier le message global",
  "editingProject": "Modification du projet",
  "editSystemPrompts": "Modifier les requêtes système",
  "filePathPrompt": "Requête du chemin d'accès",
  "fillingInSamples": "Remplissage des échantillons",
  "generalPrefix": "Préfixe général",
  "globalChatbots": "Chatbots globaux",
  "globalRepositories": "Dépôts globaux",
  "hideNextWeek": "Masquer la semaine prochaine",
  "hideSatSun": "- Sam/Dim",
  "manageAdmins": "Gérer les administrateurs",
  "oneWeek": "1 semaine",
  "openMetricsPanel": "Ouvrir le panneau Métriques/IAP",
  "openTodoList": "Ouvrir la liste à faire",
  "optimizedQuestionPrompt": "Requête de question optimisée",
  "plannertech": "Plannertech",
  "plannertechSuite": "Suite Plannertech",
  "plannertechTeamPlan": "Plan d'équipe Plannertech",
  "previousConversation": "Conversation précédente",
  "librarianLogoAlt": "Logo du Librarian",
  "qcLibrarianForCompany": "QC Librarian pour {{company}}",
  "relevantDocumentation": "Documentation pertinente",
  "repositoryHasUnprocessedFilesInfo": "Il y a des fichiers non traités dans ce dépôt",
  "repositoryIsEmpty": "Ce dépôt est vide",
  "repositoryPrefix": "Préfixe du dépôt",
  "repositoryProcessingInProgressInfo": "Le dépôt traite actuellement les fichiers. Veuillez actualiser la page pour voir la progression",
  "sampleAllocation": "Allocation d'échantillons",
  "mbWithValue": "{{value}} Mo",
  "seatsWithCount": "Sièges : {{count}}",
  "excludingToday": "À l'exclusion d'aujourd'hui",
  "unplanning": "Déplanification",
  "activeSeats": "Sièges actifs : {{count}}",
  "totalSeats": "Sièges normaux : {{count}}",
  "purchasedSeats": "Sièges achetés : {{count}}",
  "globalMessage": "Message global",
  "clearGlobalMessageConfirm": "Êtes-vous certain de vouloir effacer le message global ? Cela le supprimera pour tous les utilisateurs.",
  "samplesCount": "Échantillons : {{count}}",
  "locations": "Lieux",
  "customers": "Clients",
  "editCustomer": "Modifier le client",
  "addCustomerTitle": "Ajouter un client",
  "deleteCustomer": "Supprimer le client",
  "customerName": "Nom du client",
  "customerStatus": "Statut du client",
  "active": "Actif",
  "passive": "Passif",
  "allowedDomains": "Domaines autorisés",
  "allowedPerformers": "Exécutants autorisés",
  "seatsPurchased": "Sièges achetés",
  "customerApiKey": "Clé API client",
  "durationFormatDDHH": "DD:HH",
  "durationFormatHHMMSS": "HH:MM:SS",
  "durationFormatHHMM": "HH:MM",
  "durationFormatHH": "HH",
  "durationFormatDDHHMM": "DD:HH:MM",
  "continue": "Continuer",
  "showNextWeek": "Afficher la semaine prochaine",
  "showSatSun": "+ Sam/Dim",
  "topDescriptionPrompt": "Requête de description supérieure",
  "twoWeeks": "2 semaines",
  "updateHelpPage": "Mettre à jour la page d'aide",
  "userAlreadyLoggedInTakeOver": "Utilisateur déjà connecté. Pour reprendre la session, appuyez sur confirmer",
  "zoomIn": "Zoom avant",
  "zoomOut": "Zoom arrière",
  "constraintWarningTitle": "{{count}} avertissement(s) s'est/se sont produit(s)",
  "assetStatusFree": "Libre",
  "assetStatusBooked": "Réservé",
  "dateTo": "au",
  "futureAnalysisTaskCantBeFinished": "Une tâche d'analyse future ne peut pas être terminée",
  "tableNotFound": "Tableau non trouvé",
  "conversionSheetFilename": "Feuille de conversion.xlsx",
  "selectTeam": "Select a team to log in to",
  "admin": "Admin",
  "customerAdmin": "Admin Client",
  "attachFile": "Joindre un fichier",
  "removeFile": "Supprimer le fichier",
  "fileTooLarge": "Le fichier est trop volumineux (max 10 Mo)",
  "tooManyFiles": "Maximum 3 fichiers par message",
  "unsupportedFileType": "Type de fichier non pris en charge. Autorisés : PDF, DOCX, TXT, CSV, PNG, JPG, GIF, WEBP"
}
